import { HttpContextToken } from '@angular/common/http';

/** A 401 on this request refers to application credentials, not the user's session. */
export const APPLICATION_AUTH_REQUEST = new HttpContextToken<boolean>(() => false);
